// Mirror of Public::PageContentHelpers#section_content's hidden marker: a
// section the admin toggled off arrives as { _hidden: true } instead of its
// content. Guard any section whose copy can fall back to i18n defaults —
// value guards alone would resurrect it with the fallback text.
export function sectionHidden(content?: { _hidden?: boolean } | null): boolean {
  return content?._hidden === true
}
